// Tiffin Data Models

export const TiffinCenter = {
  centerId: 0,
  centerName: '',
  centerDescription: '',
  centerCity: '',
  centerState: '',
  countryId: 0,
};

export const TiffinPlan = {
  planId: 0,
  planName: '',
  planDescription: '',
  planType: '', // weekly, monthly, custom
  mealCount: 0,
  pricePerMeal: 0,
  totalPrice: 0,
  centerId: 0,
  cuisineType: '', // vegetarian, non-vegetarian, vegan
  deliveryDays: '', // comma-separated days
};

export const TiffinSubscription = {
  subscriptionId: 0,
  planId: 0,
  userId: 0,
  startDate: '',
  endDate: '',
  status: 'active', // active, paused, cancelled
  paymentStatus: 'unpaid', // unpaid, paid, refunded
  totalAmount: 0,
  discountPercent: 0,
  finalAmount: 0,
  deliveryAddress: '',
};

export const TiffinMeal = {
  mealId: 0,
  mealName: '',
  mealDescription: '',
  cuisineType: '',
  ingredients: '',
  allergens: '',
  nutritionInfo: '',
  imageUrl: '',
};

export const TiffinDelivery = {
  deliveryId: 0,
  subscriptionId: 0,
  mealId: 0,
  deliveryDate: '',
  deliveryTime: '',
  status: 'pending', // pending, delivered, cancelled
  deliveryAddress: '',
  notes: '',
};

export const TiffinPayment = {
  paymentId: 0,
  subscriptionId: 0,
  amount: 0,
  paymentMethod: '', // credit_card, debit_card, bank_transfer
  paymentDate: '',
  transactionId: '',
  status: 'pending', // pending, completed, failed
};

export const TiffinUser = {
  userId: 0,
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  address: '',
  city: '',
  state: '',
  zipCode: '',
  country: '',
  countryId: 0,
  dietaryPreferences: '',
};

// Jain food preference (no onion, garlic or root vegetables).
// Besides the Is_Jain_Food flag on Kitchen_Order, the marker is prefixed to the
// order notes so every existing surface (emails, receipts, admin views) shows it
// without further changes.
export const JAIN_FOOD_LABEL = 'Jain Food';
export const JAIN_FOOD_HINT = 'No onion, garlic or root vegetables';
export const JAIN_FOOD_NOTE = 'JAIN FOOD (no onion, garlic, root vegetables)';

export const buildOrderNotes = (notes, isJainFood) => {
  const text = (notes || '').trim();
  if (!isJainFood) return text;
  return text ? `${JAIN_FOOD_NOTE} - ${text}` : JAIN_FOOD_NOTE;
};
